export default {
  dobFormat: 'DD/MM/YYYY'
};
